<template>
  <div v-if="isShowNotice" @click="onSwitchClick">
    <div class="notice-message">
      <div class="notice">
        <img class="icon-notice" src="../../../../image/realname/laba.png" alt />
        <div class="content">
          <swiper :options="swiperOption" ref="mySwiper" v-if="!isOpen">
            <swiper-slide v-for="(item, index) in noticeSlideList" :key="index">
              <div class="message-item">{{ item }}</div>
            </swiper-slide>
          </swiper>
        </div>
        <div>{{`${noticeCount}个通知`}}</div>
        <img class="arrow" src="../../../../image/schedule/icon_switch_arrow@2x.png" alt />
      </div>
    </div>
    <!-- 展开文字，布局为 fixed -->
    <div class="notice-message open-layout" v-show="isOpen">
      <div class="notice">
        <img class="icon-notice" src="../../../../image/realname/laba.png" alt />
        <div class="label-tip" v-show="isOpen">温馨提示：</div>
        <img class="arrow" src="../../../../image/schedule/icon_switch_arrow@2x.png" :style="{transform: `rotate(${isOpen ? '180deg' : '0deg'})`}" alt />
      </div>
      <template v-show="isOpen">
        <div class="desc" v-for="(message, index) in noticeList" :key="index">{{message}}</div>
      </template>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'NoticeMessage',
  props: {
    noticeMsg: {
      type: String,
      default: '',
    },
    filmLimit: {
      type: String,
      default: '',
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  computed: {
    noticeList() {
      let arr = []
      if (this.noticeMsg) {
        arr.push(this.noticeMsg)
      }
      if (this.filmLimit) {
        arr.push(this.filmLimit)
      }
      return arr
    },
    // 通知数
    noticeCount() {
      return this.noticeList.length || 0
    },
    isShowNotice() {
      return this.noticeList.length > 0
    },
    noticeSlideList() {
      let slideList = []
      if (this.noticeMsg) {
        slideList = slideList.concat(this.noticeMsg.split('，'))
      }
      if (this.filmLimit) {
        slideList = slideList.concat(this.filmLimit.split('，'))
      }
      return slideList
    },
    swiperOption() {
      return {
        direction: 'vertical',
        autoplay: {
          delay: 2000,
        },
        loop: true,
      }
    },
  },
  methods: {
    onSwitchClick() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';
.notice-message {
  padding: 10px 10px 10px 15px;
  margin-top: 44px;
  background: #fbf4d8;
  color: #e68e1a;
  font-size: 13px;

  .notice {
    display: flex;
    align-items: center;

    .icon-notice {
      width: 14px;
      height: 14px;
      margin-right: 5px;
      flex-shrink: 0;
      margin-bottom: 1px;
    }

    .content {
      height: 20px;
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      margin-right: 10px;
    }

    .message-item {
      height: 20px;
      line-height: 20px;
    }

    .label-tip {
      flex: 1;
      height: 20px;
      line-height: 20px;
    }

    .arrow {
      flex-shrink: 0;
      width: 12px;
      height: 7px;
      border: 5px solid transparent;
    }
  }

  .desc {
    margin-top: 5px;
    margin-left: 20px;
    position: relative;

    &::before {
      position: absolute;
      content: '';
      left: -7px;
      top: 10px;
      width: 2px;
      height: 2px;
      background-color: #e68e1a;
    }
  }
}

.open-layout {
  position: fixed;
  top: 44px;
  left: 0;
  right: 0;
  z-index: 9;
  margin-top: 0;
}
</style>



